import React, { useEffect, useRef, useState, useCallback } from 'react'
import {
   makeStyles,
   Grid,
   Button,
   Snackbar,
   Icon,
   Collapse,
   Paper
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
// import SearchFilters from './SearchFilters'
import TuneIcon from '@material-ui/icons/Tune'
import Alert from '@material-ui/lab/Alert'

const useStyles = makeStyles(theme => ({
   '@global': {
      '*::-webkit-scrollbar': {
         width: '3px'
      },
      '*::-webkit-scrollbar-track': {
         borderRadius: '10px',
         width: '1px'
      },
      '*::-webkit-scrollbar-thumb': {
         backgroundColor: 'rgba(0,0,0,.2)'
      }
   },
   layoutContainer: {
      // padding: theme.spacing(2, 2, 0, 2),
      height: '100%',
      width: '100%',
      flexDirection: 'column'
   },
   layoutHeader: {
      display: 'flex',

      marginBottom: theme.spacing(4)
   },
   openPopoverButton: {
      display: 'flex',
      justifyContent: 'space-between',
      border: 'none',
      padding: '5px 10px',
      textTransform: 'none',
      fontWeight: 'bold',
      width: '344px',
      height: 44,
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '0px 2px 2px #00000029',
      borderRadius: '4px',
      opacity: 1,
      '&:hover': {
         background: 'white',
         color: 'rgb(50, 100, 220)'
      },
      '& .MuiButton-label': {
         justifyContent: 'start'
      }
   },
   buttonTitle: {
      width: '80%',
      textAlign: 'start'
   },
   openPopoverButtonIcon: {
      borderRadius: '50%',
      backgroundColor: 'rgb(244, 247, 254)',
      padding: '2px'
   },
   tableContainer: {
      flex: '1 1 auto',
      width: '100%'
   },
   popoverTitleContainer: {
      margin: '5px',
      flex: '0 1 auto',
      justifyContent: 'space-between',
      fontWeight: 'bold',
      fontSize: '16px',
      background: 'white',
      color: '#3264DC'
   },
   popoverFormContainer: {
      flex: '1 1 auto',
      width: '344px'
   },
   expandMoreIcon: {
      transition: '0.2s ease-in-out'
   },
   expandMoreIconRotate: {
      transform: 'rotateZ(-180deg)'
   },
   // root: {
   //     maxHeight: '86%'
   // },
   // paper: {
   //     height: 'auto'
   // },
   searchFilters: {
      width: '100%'
   },
   buttonContainer: {
      marginTop: 5
   },
   containerAlertStatus: {
      minWidth: '400px'
   },
   alertStyles: {
      marginLeft: '100px',
      minWidth: '300px'
   },
   MuiAlertMessage: {
      marginLeft: '20px'
   },
   alertStyles2: {
      marginLeft: '100px',
      minWidth: '300px',
      backgroundColor: 'white'
   },
   collapse: { position: 'absolute', zIndex: 100, width: 344 }
}))

function SearchQuestionarieLayout({
   form,
   table,
   title,
   searchFilters,
   search,
   popoverProp,
   setPopoverProp,
   onRemoveFilter,
   alertClose,
   showError,
   textError,
   confirmAlertStatus
}) {
   const classes = useStyles()

   const buttonRef = useRef()

   const [, updateState] = useState()
   const forceUpdate = useCallback(() => updateState({}), [])

   const handleClick = () => {
      setPopoverProp(!popoverProp)
   }

   useEffect(() => {
      forceUpdate()
   }, [buttonRef])

   return (
      <Grid className={classes.layoutContainer}>
         <Grid className={classes.layoutHeader}>
            <Grid className={classes.buttonContainer}>
               <Button
                  ref={buttonRef}
                  variant="contained"
                  className={classes.openPopoverButton}
                  style={(popoverProp && { color: '#3264DC' }) || {}}
                  onClick={handleClick}
                  startIcon={<Icon fontSize="medium">filter_alt</Icon>}
                  endIcon={
                     <ExpandMore
                        fontSize="medium"
                        className={
                           popoverProp
                              ? classes.expandMoreIconRotate
                              : classes.expandMoreIcon
                        }
                        onClick={handleClick}
                     />
                  }
               >
                  <span className={classes.buttonTitle}>{title}</span>
               </Button>
               <Collapse className={classes.collapse} in={popoverProp}>
                  <Paper elevation={1} className={classes.popoverFormContainer}>
                     {form}
                  </Paper>
               </Collapse>
            </Grid>
            <Snackbar
               className={classes.containerAlertStatus}
               open={showError}
               autoHideDuration={6000}
               onClose={() => alertClose()}
               anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
               <Alert
                  onClose={() => alertClose()}
                  className={classes.alertStyles}
                  variant="filled"
                  severity="error"
                  classes={{ message: classes.MuiAlertMessage }}
               >
                  {textError}
               </Alert>
            </Snackbar>
            <Snackbar
               className={classes.containerAlertStatus}
               open={confirmAlertStatus}
               autoHideDuration={6000}
               onClose={() => alertClose()}
               anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
               <Alert
                  onClose={() => alertClose()}
                  className={classes.alertStyles2}
                  variant="outlined"
                  severity="info"
               >
                  {'PDF cargado exitosamente'}
               </Alert>
            </Snackbar>
         </Grid>
         <Grid className={classes.tableContainer}>{table}</Grid>
      </Grid>
   )
}

export default SearchQuestionarieLayout
